(function () {
    'use strict';

    var imApp = angular.module('imApp');

    imApp.component('productCalc', {
        templateUrl: 'views/components/views/productCalc/productCalc.template.html?v=' + imApp.version,
        controllerAs: 'vm',
        controller: [
            '$stateParams',
            'stateService',
            'utilityService',
            'modalService',
            'productCalcService',
            'translateService',
            'rememberService',
            '$q',
            function ($stateParams, stateService, utilityService, modalService, productCalcService, translateService, rememberService, $q) {
                // #region VARIABLES & DEFINITIONS

                var rememberIdPricelistId = 'w_productCalcPricelistId';

                var vm = this;
                let prodId = $stateParams.prod_id;
                let argType = $stateParams.argtype;
                let argValue = $stateParams.argvalue;

                let translations = {
                    error: '',
                    ok: '',
                };

                let calcQuanityNew = '';
                let salesPricePrSkuCalcValutaNew = '';
                let marginPstNew = '';

                vm.goToFunc = function (state) {
                    var go = function (parms) {
                        stateService.go(state, parms);
                    };

                    switch (state) {
                        case 'productbom':
                            go(vm.model.setting.prod_keyno);
                        case 'orderlinebom':
                            go({
                                orderline_keyno: vm.model.setting.orderline_keyno,
                            });
                            break;
                        case 'productsconfig':
                            go({
                                argtype: 'productcalc',
                                headno: '0',
                                lineno: vm.model.setting.orderline_keyno,
                            });
                            break;
                        default:
                            break;
                    }
                };

                vm.model = {
                    argType: argType,
                    prodIdButtons: [{ id: 'goto', icon: 'glyphicon glyphicon-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('product', vm.model.setting.prod_keyno) }],
                    orderLineButtons: [{ id: 'goto', icon: 'glyphicon glyphicon-chevron-right', color: 'primary', type: 'primary', onClick: { click: vm.goToFunc, state: 'orderlinebom' } }],
                    selectListPriceList: [],
                    setting: {
                        show_product_structure: '0',
                    },
                    creatingOrderLine: false,
                    lockedUpdate: false,
                    //retrievingGrid: false,
                    lockedSave: false,
                    gridReady: false,
                };

                vm.grid = {
                    dataTask: {
                        rememberId: '',
                        loadSetupId: null,
                        loadData: {},
                        addRow: {
                            method: null,
                            parameters: null,
                            autoSave: false,
                            confirm: false,
                        },
                        removeRow: {
                            method: null,
                            parameters: null,
                            autoSave: false,
                            confirm: false,
                        },
                        saveData: {
                            method: null,
                            parameters: null,
                            autoSave: false,
                            confirm: false,
                        },
                    },
                    translations: [],
                    config: {
                        editColumns: [
                            //{ key: 'test_column' }
                            //'prod_name', 'stock_stockvalue', 'is_selected', { key: 'test_column', lookup: 1900, relations: [{ key: 'stockplace_name', value: 'item_id' }], optionfunc: true }, 'reg_date'
                        ],
                        toolbar: {
                            hidden: false,
                            pdfExport: true,
                            excelExport: true,
                            filter: true,
                            columnVisibility: true,
                            headers: true,
                            edit: false,
                            lock: false,
                            add: false,
                            delete: false,
                            save: false,
                            wrapping: true,
                            layouts: true,
                            buttons: [
                                //{ name: 'toggle_product_structure', text: 'toggle_product_structure', func: function (data) { toggleProductStructure(data); }, icon: 'none', cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r', translate: true, disabled: function () { return false; } }
                                //{ name: 'cancel', text: '', func: function () { console.log('this is a test with default icon'); } },
                                //{ name: 'test', text: '', func: function () { testItems(); } },
                                //{ name: 'customSave', text: '', func: function () { saveItems(); }, icon: 'save' },
                                //{ name: 'customAddBefore', text: '', func: function () { addItemBefore(); }, icon: 'insert-up' },
                                //{ name: 'customAddAfter', text: '', func: function () { addItemAfter(); }, icon: 'insert-down' },
                                //{ name: 'customDelete', text: '', func: function () { deleteItem(); }, icon: 'delete' }
                            ],
                        },
                        fixedHeader: true,
                        keepSortOnAdd: false,
                        keepSortOnCheckbox: false,
                        keepSortOnIsSelected: false,
                        rowClick: false,
                        specialFunc: {
                            newTab: true,
                            buttons: [
                                //{ name: 'test', text: '', func: function (data) { testItems(data); }, icon: 'far-star' }
                            ],
                        },
                        css: {
                            altColor: true,
                            textWrapping: false,
                        },
                        onDataSourceChanges: function (e) {
                            //console.log('onDataSourceChanges');
                            //console.dir(e);
                        },
                    },
                    kendo: {
                        height: null,
                        aggregate: true,
                        pager: false,
                        selectable: false, //'multiple, row'
                        //persistSelection: false,
                        filterable: false,
                    },
                    optionfunc: function (data) {
                        optionfunc(data.data);
                    },
                    gridfunc: null,
                };

                var optionfunc = function (data) {
                    //console.log('optionfunc');
                    //if (angular.isDefined(data.func) && data.func === 'CellClickHandler') {
                    //	console.log('optionfunc - CellClickHandler');
                    //	console.dir(data);
                    //}
                    //if (angular.isDefined(data.func) && data.func === 'OnCellClose') {
                    //	console.log('optionfunc - OnCellClose');
                    //	console.dir(data);
                    //}
                    //if (angular.isDefined(data.func) && data.func === 'LookupCellEditor') {
                    //	console.log('optionfunc - LookupCellEditor');
                    //	console.dir(data);
                    //}
                };

                // #endregion VARIABLES & DEFINITIONS

                // #region TRANSLATE SERVICE

                async function translate() {
                    let data = await translateService.translateBatch(translations);

                    Object.keys(translations).forEach((key) => {
                        if (data?.[key]) translations[key] = data[key];
                    });
                }

                // #endregion TRANSLATE SERVICE

                // #region LOAD PROCEDURE FUNCTION CALLS

                var remember = function () {
                    rememberService.remember(rememberIdPricelistId, vm.model.setting.pricelist_id);
                    console.log(vm.model.setting.pricelist_id);
                };

                var loadProductCalc = function () {
                    productCalcService
                        .getProductCalc({
                            prod_id: prodId,
                            argtype: argType,
                            argvalue: argValue,
                        })
                        .then(function (data) {
                            angular.copy(data[0], vm.model.setting);

                            calcQuanityNew = vm.model.setting.calc_quantity;
                            salesPricePrSkuCalcValutaNew = vm.model.setting.sales_price_pr_sku_calc_valuta;
                            marginPstNew = vm.model.setting.margin_pst;

                            if (vm.model.setting.nbr_of_orderlines > 0) {
                                loadGrid();
                            }
                        });
                };

                var loadSelectListPriceList = function () {
                    productCalcService.listPriceList(vm.model.setting).then(function (result) {
                        angular.copy(result, vm.model.selectListPriceList);
                    });
                };

                function retrievePriceList() {
                    if (utilityService.validateParmsValue(vm.model.setting.pricelist_id) !== true) return;

                    productCalcService.changePriceList(vm.model.setting).then((response) => {
                        if (response[0] && response[0].errorcode !== '0') {
                            modalService.show({
                                type: 'warning',
                                title: translations.error,
                                message: response[0].errormessage,
                                buttons: [
                                    {
                                        label: translations.ok,
                                        cssClass: 'btn-warning',
                                        action: (dialogItself) => {
                                            dialogItself.close();
                                        },
                                    },
                                ],
                            });
                        } else {
                            vm.model.setting.sales_price_pr_sku_calc_valuta = response[0].sales_price_pr_sku_calc_valuta;

                            recalcColumns('sales_price_pr_sku_calc_valuta');
                        }
                    });
                }

                async function recalcColumns(colname) {
                    switch (colname) {
                        case 'sales_price_pr_sku_calc_valuta':
                        case 'margin_pst':
                            const response = (await productCalcService.changeColumn({ ...vm.model.setting, colname_changed: colname }))[0];

                            vm.model.setting = { ...vm.model.setting, ...response };

                            loadGrid();
                            break;
                        default:
                            break;
                    }
                }

                async function loadGrid() {
                    if (utilityService.validateParmsValue(vm.model.setting.view_id) === true) {
                        vm.grid.dataTask.rememberId = vm.model.setting.view_id;
                    }

                    if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) === true) {
                        vm.grid.dataTask.loadData = {
                            method: vm.model.setting.p2_datatask_keyno,
                            parameters: vm.model.setting,
                        };

                        if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
                    }

                    vm.model.gridReady = true;
                    //vm.model.retrievingGrid = false;
                }

                vm.$onInit = async function () {
                    translate();
                    await loadSelectListPriceList();
                    await loadProductCalc();
                };

                // #endregion LOAD PROCEDURE FUNCTION CALLS

                // #region FIELD CHANGE MULTI FUNCTIONS

                vm.onChanged = function (value, id) {
                    switch (id) {
                        case 'show_choosable_products':
                            if (utilityService.validateWatchValue(value, vm.model.setting.show_choosable_products) !== true) return;

                            vm.model.setting.show_choosable_products = value;

                            if (utilityService.validateParmsValue(vm.model.setting.show_choosable_products, true) !== true) return;

                            loadGrid();
                            break;
                        case 'pricelist_id':
                            if (utilityService.validateWatchValue(value, vm.model.setting.pricelist_id) !== true) return;

                            vm.model.setting.pricelist_id = value;

                            if (utilityService.validateParmsValue(vm.model.setting.pricelist_id, true) !== true) return;

                            remember();
                            retrievePriceList();
                            break;
                        default:
                            utilityService.setValueToVariable(value);
                            break;
                    }
                };

                // #endregion FIELD CHANGE MULTI FUNCTIONS

                // #region ON BLUR MULTI FUNCTIONS

                vm.onBlur = function (id) {
                    switch (id) {
                        case 'calc_quantity':
                            if (utilityService.validateParmsValue(vm.model.setting.calc_quantity, true) !== true) return;
                            if (vm.model.setting.calc_quantity === calcQuanityNew) return;

                            calcQuanityNew = vm.model.setting.calc_quantity;

                            vm.createChanges();
                            break;
                        case 'sales_price_pr_sku_calc_valuta':
                            if (utilityService.validateParmsValue(vm.model.setting.sales_price_pr_sku_calc_valuta, true) !== true) return;
                            if (vm.model.setting.sales_price_pr_sku_calc_valuta === salesPricePrSkuCalcValutaNew) return;

                            salesPricePrSkuCalcValutaNew = vm.model.setting.sales_price_pr_sku_calc_valuta;

                            recalcColumns(id);
                            break;
                        case 'margin_pst':
                            if (utilityService.validateParmsValue(vm.model.setting.margin_pst, true) !== true) return;
                            if (vm.model.setting.margin_pst === marginPstNew) return;

                            marginPstNew = vm.model.setting.margin_pst;

                            recalcColumns(id);
                            break;
                        default:
                            break;
                    }
                };

                // #endregion ON BLUR MULTI FUNCTIONS

                // #region BUTTON CREATE PROCEDURE FUNCTION CALL

                vm.createChanges = function () {
                    vm.model.creatingOrderLine = true;

                    productCalcService.createOrderLine(vm.model.setting).then(function (data) {
                        if (data[0].errorcode !== '0') {
                            modalService.show({
                                type: 'danger',
                                title: translations.error,
                                message: data[0].errormessage,
                                buttons: [
                                    {
                                        label: 'OK',
                                        cssClass: 'btn-warning',
                                        action: function (dialogItself) {
                                            dialogItself.close();
                                            vm.model.creatingOrderLine = false;
                                        },
                                    },
                                ],
                            });
                        } else {
                            vm.model.creatingOrderLine = false;
                            loadProductCalc();
                            //vm.grid.gridfunc.rebind();
                        }
                    });
                };

                // #region BUTTON SAVE PROCEDURE FUNCTION CALL

                vm.updateChanges = function () {
                    vm.model.lockedUpdate = true;

                    productCalcService.updateOrderLine(vm.model.setting).then((response) => {
                        if (response[0] && response[0].errorcode !== '0') {
                            modalService.show({
                                type: 'warning',
                                title: translations.error,
                                message: response[0].errormessage,
                                buttons: [
                                    {
                                        label: translations.ok,
                                        cssClass: 'btn-warning',
                                        action: function (dialogItself) {
                                            dialogItself.close();
                                            vm.model.lockedUpdate = false;
                                        },
                                    },
                                ],
                            });
                        } else {
                            if (window.location.href.includes('?ispopup')) {
                                window.opener.postMessage({
                                    type: 'ttData',
                                    data: vm.model.setting,
                                    messages: response[0]?.messages ?? [],
                                });

                                setTimeout(() => {
                                    window.close();
                                    vm.model.lockedUpdate = false;
                                });
                            } else {
                                vm.model.lockedUpdate = false;
                                stateService.back();
                            }
                        }
                    });
                };

                // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

                // #region BUTTON SAVE PROCEDURE FUNCTION CALL

                vm.saveChanges = function () {
                    vm.model.lockedSave = true;

                    productCalcService.saveObj(vm.model.setting).then((response) => {
                        if (response[0] && response[0].errorcode !== '0') {
                            modalService.show({
                                type: 'warning',
                                title: translations.error,
                                message: response[0].errormessage,
                                buttons: [
                                    {
                                        label: translations.ok,
                                        cssClass: 'btn-warning',
                                        action: (dialogItself) => {
                                            dialogItself.close();
                                            vm.model.lockedSave = false;
                                        },
                                    },
                                ],
                            });
                        } else {
                            vm.model.lockedSave = false;
                        }
                    });
                };

                // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

                //var toggleProductStructure = function () {
                //    if (vm.model.setting.show_product_structure === '1') {
                //        vm.model.setting.show_product_structure = '0';
                //    } else {
                //        vm.model.setting.show_product_structure = '1';
                //    }

                //    vm.grid.gridfunc.rebind();
                //};

                // #endregion BUTTON CREATE PROCEDURE FUNCTION CALL

                //vm.retriveGrid = function () {
                //    vm.model.retrievingGrid = true;
                //    loadGrid();
                //    vm.grid.gridfunc.rebind();
                //};
            },
        ],
    });
})();
